<template>
    <div class="mt-5">
        <h3>{{ $t('connect.arrayFieldView') }}</h3>
        <div class="box-field-view flex-row">
            <template v-for="(item, index) in listFieldChecked">
                <el-checkbox v-model="item.checked" :label="item.label" class="ml-0" border :key="'field' + index" @change="changeFieldView()"></el-checkbox>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'array-field-view',
    props: {
        listField: { required: true },
        arrayFieldView: { required: true }
    },
    data() {
        return {
            listFieldChecked: []
        };
    },
    computed: {
        watchFieldView() {
            return [this.listField, this.arrayFieldView];
        }
    },
    watch: {
        watchFieldView: {
            deep: true,
            immediate: true,
            handler() {
                let arrayField = Object.values(this.listField);
                if (!arrayField) return;
                this.listFieldChecked = arrayField.map((value) => ({
                    code: value.code,
                    label: value.label,
                    checked: true
                }));
                if (!this.arrayFieldView) return;
                this.listFieldChecked.forEach((itemFieldChecked) => {
                    itemFieldChecked.checked = false;
                });
                this.arrayFieldView.forEach((itemFieldView) => {
                    this.listFieldChecked.forEach((itemFieldChecked) => {
                        if (itemFieldView.code === itemFieldChecked.code) {
                            itemFieldChecked.checked = true;
                        }
                    });
                });
            }
        }
    },
    methods: {
        changeFieldView() {
            let arrayFieldViewMap =
                this.listFieldChecked
                    ?.filter((item) => !!item.checked)
                    .map((value) => ({
                        code: value.code,
                        label: value.label
                    })) ?? null;
            this.$emit('update:arrayFieldView', arrayFieldViewMap);
        }
    }
};
</script>
